import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SedsCoreButtonComponent } from './seds-core-button.component';

@NgModule({
  declarations: [SedsCoreButtonComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  exports: [SedsCoreButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsCoreButtonModule {}
